<template>
	<div>
		<div class="midlle" >
			<div class="myProject">
				<div class="title">
					<span class="tit">我已发布的求助</span>
					<!-- <p>您已发布10个求助，共计浏览<span>30</span>次,收藏<span>10</span>次，点赞<span>10</span>次</p> -->
				</div>
				<div v-if="false">
					<div class="myProject-main">
						<div class="item" v-for="(item,index) in myProject">
							<div class="main">
								<div class="head">
									<div>浏览: <span>{{item.browse}}</span></div>
									<div>收藏: <span>{{item.collect}}</span></div>
									<div>点赞: <span>{{item.like}}</span></div>
								</div>
								<div class="body">
									<div class="image">
										<img src='../../assets/images/computer.png' alt="">
									</div>
					
										<div style="width: 100%;display: flex;justify-content: center;">
											<p style="width: 100px;text-align: center;font-size: 18px;">{{item.title}}</p>
										</div>
									<div class="status">
										<p v-if="item.loading" style="color: #0052D9;">系统审核中</p>
										<p v-else>投条<span style="color: #0052D9;">{{item.toutiao}}</span>次 <span style="margin: 0 10px;">|</span> 成交记录</p>
									</div>
								</div>
							</div>
							<div class="bottom">
								<p v-if="item.status == 0">已过期，<span style="color: #0052D9;">去更新</span></p>
								<p v-else>有<span style="color: #0052D9;">{{item.new}}</span>条咨询</p>
							</div>
						</div>
					</div>
					<div class="body-mid-footer">
						加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>
			<div class="myProject">
				<div class="title">
					<span class="tit">我已应助的活动</span>
					<!-- <p>您已应助10个活动，共计浏览<span>30</span>次,收藏<span>10</span>次，点赞<span>10</span>次</p> -->
				</div>
				<div v-if="false">
					<div class="myProject-main">
						<div class="item" v-for="(item,index) in myProject">
							<div class="main">
								<div class="head">
									<div>浏览: <span>{{item.browse}}</span></div>
									<div>收藏: <span>{{item.collect}}</span></div>
									<div>点赞: <span>{{item.like}}</span></div>
								</div>
								<div class="body">
									<div class="image">
										<img src='../../assets/images/computer.png' alt="">
									</div>
					
										<div style="width: 100%;display: flex;justify-content: center;">
											<p style="width: 100px;text-align: center;font-size: 18px;">{{item.title}}</p>
										</div>
									<div class="status">
										<p v-if="item.loading" style="color: #0052D9;">系统审核中</p>
										<p v-else>投条<span style="color: #0052D9;">{{item.toutiao}}</span>次 <span style="margin: 0 10px;">|</span> 成交记录</p>
									</div>
								</div>
							</div>
							<div class="bottom">
								<p v-if="item.status == 0">已过期，<span style="color: #0052D9;">去更新</span></p>
								<p v-else>有<span style="color: #0052D9;">{{item.new}}</span>条咨询</p>
							</div>
						</div>
					</div>
					<div class="body-mid-footer">
						加载更多<img src='../../assets/images/darrwo.png' alt="">
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>
			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">平台活动/求助应助</div>
				</div>
				<div v-if="false">
					<div style="display:flex;align-items: center;justify-content: space-between;padding: 0 15px;margin-bottom: 15px;">
						<div style="display:flex;align-items: center;">
						
							<div style="display: flex;align-items: baseline;cursor: pointer;margin-left: 15px;">
								时间<img src="../../assets/images/shaixuan.png" alt="" style="width: 15px;height: 13px;">
							</div>
						</div>
						<el-checkbox-group v-model="checkedCities">
							<el-checkbox v-for="city in cities6" :label="city" :key="city">{{ city }}</el-checkbox>
						</el-checkbox-group>
					</div>
					<el-table :data="tableData3" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="type" label="类型" width="84" :resizable="false">
						</el-table-column>
						<el-table-column  label="类别" width="60" :resizable="false">
						  <template slot-scope="scope">
							  <p v-for="item in scope.row.leibie">{{item}}</p>      
							</template>
						</el-table-column>
						<el-table-column prop="title" label="标题" width="135" :resizable="false">
						</el-table-column>
						<el-table-column prop="status" label="状态" width="75" :resizable="false">
						</el-table-column>
						<el-table-column prop="date" label="当前状态开始时间" width="135" :resizable="false">
						</el-table-column>
						<el-table-column prop="name" label="当前状态用户" width="120" :resizable="false">
						</el-table-column>
						<el-table-column label="项目金额" width="123" :resizable="false">
							<template slot-scope="scope">
								 <p>{{scope.row.money}}元</p>
								 <div v-if="scope.row.wrz"
									@click="centerDialogVisible = true"
									style="width: 69px;height: 27px;background: #E1E9F7;
									line-height: 27px;font-size: 14px;color: #0052D9;text-align:center;
									margin: auto;cursor: pointer;"
								 >
									 未认证
								 </div>
							</template>
						</el-table-column>
						<el-table-column label="查看详情" width="106" :resizable="false">
							<div class="link" style="color: #0052D9 !important;">
								详请链接
							</div>
						</el-table-column>
								
					</el-table>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
					<el-dialog
					:lock-scroll="false"
					  title="金额认定说明"
					  :visible.sync="centerDialogVisible"
					  width=" 732px"
					  center>
						<p style="">
							<p style="text-indent: 2em;color: #888;line-height: 25px;">
								银行卡认证确认金额请您注意以下4 点： 1.请您注意在收到我们给您汇款成功，需要确认金额的邮件后再查询您在银行认证第三步登记的银行账户明细。 2.需要查询的是账户明细中最近期的打款金额，您已经有过5次提现成功的记录，请您查询在收到第6次的款项后，将第6次的单笔款项输入，而不是账户总额或者几次打款的累计。3.我们给您汇入的款项都小于1元，而且您在收支明细中是可以查到支付宝给您打的单笔金额的。4.输入的时候注意在半角状态下输入，精确到小数点后两位。符合以上4 点后，您可以登录www.alipay.com－您的支付宝账户，进入后看到“您好，*** 欢迎回来。”的下面“您的支付宝认证正在进行中，请点此查看详细信息”，－点击查看进入银行账户核实，就会有个确认金额的入口，在此入口输入我们支付宝给您打的小于1.00元的款项就可以了，确认成功后，您的银行卡认证就成功了。请您注意您有两次机会确认此金额。如果两次金额确认错误，银行卡认证会失败，您需要重新申请银行卡认证。感谢您的支持！
							</p>
							    <br>
								<p style="text-indent: 2em;color: #888;line-height: 25px;">
							      银行卡认证确认金额请您注意以下4 点： 1.请您注意在收到我们给您汇款成功，需要确认金额的邮件后再查询您在银行认证第三步登记的银行账户明细。 2.需要查询的是账户明细中最此查看详细信息”，－点击查看进入银行账户核实，就会有个确认金额的入口，在此入口输入我们支付宝给您打的小于1.00元的款项就可以了，确认成功后，您的银行卡认证就成功了。请您注意您有两次机会确认此金额。如果两次金额确认错误，银行卡认证会失败，您需要重新申请银行卡认证。感谢您的支持！
								</p>
						</p>
						<div style="height: 112px;background: #0052D9;margin-top: 30px;color: white;padding: 20px 30px;box-sizing: border-box;">
							<h3 style="font-size: 20px;margin-bottom: 25px;">平台联系方式</h3>
							<p style="font-size: 18px;"><span><i class="el-icon-message"></i><span style="margin-left: 8px;">PINGT@163.COM</span></span>	<span style="margin-left: 80px;"><i class="el-icon-phone-outline"></i><span style="margin-left: 8px;">13596823578</span></span></p>
						</div>
					 
					</el-dialog>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const cityOptions6 = ['发布', '收藏', '点赞'];
	export default{
		data() {
			return{
				centerDialogVisible:false,
				cities6: cityOptions6,
				checkedCities: [],
				myProject:[
					{
						title:'惯性颗粒流SPH模拟',
						collect:100,
						browse:100,
						like:100,
						status:0,
						toutiao:2,
						new:2,
						loading:true
					},
					{
						title:'惯性颗粒流SPH模拟',
						collect:100,
						browse:100,
						like:100,
						status:1,
						toutiao:2,
						new:2,
						loading:false
					},
					{
						title:'惯性颗粒流SPH模拟',
						collect:100,
						browse:100,
						like:100,
						status:1,
						toutiao:2,
						new:2,
						loading:false
					},
				],
				tableData3: [{
					type: '项目课题',
					leibie:['发布','收藏','点赞'],
					title: 'AI只能软件开发',
					date: '2016-05-02',
					status: '已公布',
					name: ['王先生,'],
					money:3000,
					wrz:true,
					link: '详情链接',
					id: 1
				},{
					type: '项目课题',
					leibie:['收藏','点赞'],
					title: 'AI只能软件开发',
					date: '2016-05-02',
					status: '已公布',
					name: ['王先生'],
					money:3000,
					wrz:false,
					link: '详情链接',
					id: 1
				}
				],
			}
		},
		methods:{
			cc(row, column, cell, event) {
				console.log(row, column.label, cell, event);
			},
		}
	}
</script>
<style>
	.el-checkbox__input.is-checked .el-checkbox__inner{
		background-color:  #0052D9;
		border-color: #0052D9;
	}
	.el-checkbox__input.is-checked+.el-checkbox__label{
		color: #0052D9;
	}
</style>
<style lang="less" scoped>
	.midlle-body {
		padding-bottom: 10px;
	
		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}
	
		margin-top: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		background: white;
		.body-title {
			color: #0052D9;
			display: flex;
			margin-bottom: 20px;
			font-weight: bold;
			font-size: 18px;
		
			.line {
				width: 4px;
				height: 22px;
				background: #0052D9;
			}
		}
		.loading {
			cursor: pointer;
			width: 116px;
			height: 40px;
			background: #F6F6F6;
			display: flex;
			align-items: center;
			margin: 10px;
			margin-bottom: 0;
			justify-content: center;
		}
		
	}
	.midlle{
		.myProject{
			.body-mid-footer {
				width: 96%;
				margin: 0 auto;
				display: flex;
				box-sizing: border-box;
				height: 50px;
				background: #F6F6F6;
				justify-content: center;
				font-size: 18px;
				cursor: pointer;
				align-items: center;
				
				&>img {
					margin-left: 20px;
					width: 16px;
					height: 16px;
				}
			}
			.myProject-main{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				.item{
					margin-bottom: 20px;
					.bottom{
						margin-top: 15px;
						text-align: center;
						color: #888;
						width: 100%;
						height: 25px;
						background: #F6F6F6;
					}
					.main:hover{
						transform: scale(1.02);
						box-shadow: 0 0 10px #d0d0d0;
					}
					.main{
						transition: all .3s; 
						position: relative;
						align-content: flex-start;
						width: 256px;
						height: 276px;
						border: 1px solid #BFBFBF;
						display: flex;
						flex-wrap: wrap;
						padding: 15px 20px;
						box-sizing: border-box;
						justify-content: center;
						
						.body{
							.status{
								position: absolute;
								bottom: 15px;
								p{
									color: #888;
									display: flex;
									align-items: center;
								}
							}
							margin-top: 20px;
							display: flex;
							justify-content: center;
							flex-wrap: wrap;
							.image{
								width: 100px;
								height: 100px;
								border-radius: 50%;
								overflow: hidden;
								margin-bottom: 25px;
								img{
									width: 100%;
									height: 100%;
								}
							}
						}
						
					}
					
					.head{
						height: 20px;
						span{
							color: #0052D9;
						}
						width: 100%;
						font-size: 14px;
						justify-content: space-around;
						display: flex;
					}
				}
				padding: 25px 15px;
			}
			.title{
				display: flex;
				height: 40px;
				background: #E5EDFB;
				align-items: center;
				p{
					font-size: 14px;
					color: black;
					margin-left: 10px;
					span{
						color: #0052D9;
					}
				}
				.tit{
					display: inline-block;
					padding:0 20px ;
					background: #0052D9;
					height: 40px;
					line-height: 40px;
					color: white;
					font-size: 18px;
					border-radius: 0px 20px 20px 0px;
					font-weight: bold;
				}
			}
			width: 840px;
			padding: 20px 0;
			background: #FFFFFF;
		}
		width: 880px;
		    padding: 0 20px;
		    box-sizing: border-box;
	}
</style>